var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: { value: _vm.value, "no-backdrop-dismiss": "" },
      on: {
        input: function($event) {
          _vm.$emit("input", $event)
        }
      },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function(props) {
            return [
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("button.cancel"),
                  "data-test": _vm.CypressTarget("Cancel"),
                  color: _vm.SET_COLOR.buttons.cancel || "dark",
                  flat: "",
                  sparse: ""
                },
                on: {
                  click: function($event) {
                    _vm.$emit("input", false)
                  }
                }
              }),
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("button.rename"),
                  "data-test": _vm.CypressTarget("Ok"),
                  color: _vm.SET_COLOR.buttons.ok || "dark",
                  flat: "",
                  sparse: ""
                },
                on: {
                  click: function($event) {
                    _vm.$emit("changeName", _vm.chairHolderName)
                  }
                }
              })
            ]
          }
        }
      ])
    },
    [
      _c(
        "span",
        { attrs: { slot: "title" }, slot: "title" },
        [_vm._t("title")],
        2
      ),
      _c(
        "span",
        { attrs: { slot: "message" }, slot: "message" },
        [_vm._t("message")],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _c(
            "q-field",
            {
              attrs: {
                "data-test": _vm.CypressTarget("NameField"),
                error: _vm.$v.chairHolderName.$error,
                "error-label": _vm.$t("error.required.field", {
                  field: _vm.$t("field.user.name.label")
                }),
                helper: _vm.$t("label.required"),
                count: _vm.maxSeatCharacters
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "data-test": _vm.CypressTarget("Input"),
                  color: _vm.SET_COLOR.primary,
                  "float-label": _vm.$t("field.user.name.label"),
                  maxlength: _vm.maxSeatCharacters,
                  type: "text",
                  required: "",
                  autofocus: "",
                  autocomplete: "name"
                },
                on: {
                  blur: function($event) {
                    _vm.$v.chairHolderName.$touch()
                  }
                },
                model: {
                  value: _vm.chairHolderName,
                  callback: function($$v) {
                    _vm.chairHolderName =
                      typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "chairHolderName"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }